var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.438 3.177c-.323-1.25-1.365-2.24-2.615-2.552C24.49 0 15.313 0 15.313 0S6.072 0 3.74.625C2.49.938 1.448 1.927 1.125 3.177.469 5.365.469 10.052.469 10.052s0 4.636.656 6.875c.323 1.25 1.365 2.188 2.615 2.5C6.073 20 15.312 20 15.312 20s9.178 0 11.51-.573c1.25-.312 2.293-1.25 2.616-2.5.656-2.24.656-6.875.656-6.875s0-4.687-.657-6.875ZM12.291 14.271V5.833l7.604 4.22z"
})));
export default SvgPlay;